import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const LanguageSelector = () => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="flex items-center gap-2" data-testid="language-selector">
      <Globe className="w-4 h-4 text-slate-600" />
      <Select value={language} onValueChange={setLanguage}>
        <SelectTrigger className="w-[140px] bg-white" data-testid="language-select-trigger">
          <SelectValue />
        </SelectTrigger>
        <SelectContent data-testid="language-select-content">
          <SelectItem value="en" data-testid="language-option-en">English</SelectItem>
          <SelectItem value="es" data-testid="language-option-es">Español</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default LanguageSelector;